/**
 * Currency code → how it is written next to a price. Shared by every language,
 * since `€` and `zł` read the same everywhere; a language overrides the few it
 * spells its own way (Bulgarian writes BGN as `лв.`).
 */
export const CURRENCY_SYMBOLS: Record<string, string> = {
   BGN: 'BGN',
   EUR: '€',
   USD: '$',
   GBP: '£',
   JPY: '¥',
   RUB: '₽',
   PLN: 'zł',
   SEK: 'kr',
   UAH: '₴',
   INR: '₹',
   CHF: 'CHF',
   NOK: 'kr',
   DKK: 'kr',
   CZK: 'Kč',
   HUF: 'Ft',
   RON: 'lei',
};
